/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {DatasetColumnMappingOut} from './DatasetColumnMappingOut';
import {
  DatasetColumnMappingOutFromJSON,
  DatasetColumnMappingOutFromJSONTyped,
  DatasetColumnMappingOutToJSON
} from './DatasetColumnMappingOut';

/**
 *
 * @export
 * @interface ResponseStatusDatasetColumnMappingOut
 */
export interface ResponseStatusDatasetColumnMappingOut {
  /**
   *
   * @type {string}
   * @memberof ResponseStatusDatasetColumnMappingOut
   */
  status: string;
  /**
   *
   * @type {DatasetColumnMappingOut}
   * @memberof ResponseStatusDatasetColumnMappingOut
   */
  data?: DatasetColumnMappingOut | null;
  /**
   *
   * @type {string}
   * @memberof ResponseStatusDatasetColumnMappingOut
   */
  errorMsg?: string | null;
}

/**
 * Check if a given object implements the ResponseStatusDatasetColumnMappingOut interface.
 */
export function instanceOfResponseStatusDatasetColumnMappingOut(
  value: object
): value is ResponseStatusDatasetColumnMappingOut {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function ResponseStatusDatasetColumnMappingOutFromJSON(
  json: any
): ResponseStatusDatasetColumnMappingOut {
  return ResponseStatusDatasetColumnMappingOutFromJSONTyped(json, false);
}

export function ResponseStatusDatasetColumnMappingOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseStatusDatasetColumnMappingOut {
  if (json == null) {
    return json;
  }
  return {
    status: json['status'],
    data: json['data'] == null ? undefined : DatasetColumnMappingOutFromJSON(json['data']),
    errorMsg: json['error_msg'] == null ? undefined : json['error_msg']
  };
}

export function ResponseStatusDatasetColumnMappingOutToJSON(
  value?: ResponseStatusDatasetColumnMappingOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    status: value['status'],
    data: DatasetColumnMappingOutToJSON(value['data']),
    error_msg: value['errorMsg']
  };
}
